// extracted by mini-css-extract-plugin
module.exports = {"overflow":"SignContainer_overflow__4D_AV","box":"SignContainer_box__2tC0A"};